import React, { useEffect, useRef, useState } from "react";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../../Utilitie";
import axios from "axios";
import NoDataFound from "../../../../Extra/NoDataFound";
import Loading from "../../../../Extra/Loading";
const CrackRep = () => {
  const tableRef = useRef();

  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const [data, setData] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}getDatewiseCracksHdrData?startDate=${startDate}&endDate=${endDate}`,
      );
      if (response.data.status === "ok") {
        setData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-between bg-dark text-white p-1 newUiBody">
        {loading && <Loading />}
        <h5 className="">Crack Report </h5>
        <div>
          <div className="d-flex  align-items-center ">
            <b>From </b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-1"
              max={getCurrentDate()}
            />

            <b>To </b>
            <input
              type="date"
              value={endDate}
              max={getCurrentDate()}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <button
              className="ms-1 btn btn-sm btn-outline-light"
              onClick={fetchData}
            >
              Fetch
            </button>
          </div>
        </div>
      </div>

      <div
        className="table-wrapper table-responsive"
        style={{ maxHeight: "500px", overflowY: "auto" }}
      >
        {data && data?.length > 0 ? (
          <table
            ref={tableRef}
            className="table table-hover newUiTable table-striped table-bordered"
            style={{ fontSize: "13px", position: "relative" }}
          >
            <thead>
              <tr
                className="table-dark text-center sticky-top"
                style={{ fontWeight: "bold" }}
              >
                <th rowSpan={2} className="align-middle ">
                  Date
                </th>
                {data[0]?.data.map((section, index) => (
                  <th key={index}>{section.section_name}</th>
                ))}
              </tr>
              <tr className="table-dark text-center"></tr>
            </thead>
            <tbody>
              {data.map((entry, index) => (
                <tr key={index}>
                  <td className="text-center">
                    {entry.target_date.slice(0, 10)}
                  </td>
                  {entry.data.map((section, idx) => (
                    <td className="text-center" key={idx}>
                      {section.no_of_crack}
                    </td>
                  ))}
                </tr>
              ))}
              <tr className="table-dark fw-bold sticky-bottom">
                <td className="text-center">Total</td>
                {data[0]?.data.map((_, colIndex) => {
                  const columnTotal = data.reduce((sum, row) => {
                    const value = parseInt(
                      row.data[colIndex]?.no_of_crack || 0,
                    );
                    return sum + value;
                  }, 0);
                  return (
                    <td className="text-center" key={colIndex}>
                      {columnTotal}
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        ) : (
          <NoDataFound />
        )}
      </div>

      <DownloadExcel
        tableRef={tableRef}
        fileName={`Crack Data - ${getCurrentDate()}`}
      />
    </div>
  );
};

export default CrackRep;
